import {Mapper} from '@s-ui/domain'

export default class ProductsRawDataToVisibilityProductsListVOMapper extends Mapper {
  constructor({valueObject, mapper}) {
    super()
    this._valueObject = valueObject
    this._mapper = mapper
  }

  map = ({productsList}) => {
    const visibilityProductsList = productsList.map(this._mapper.map)
    return this._valueObject({
      products: visibilityProductsList
    })
  }
}
